export enum RelevantStatus {
  // these are used in bitmasking...  Don't change them
  STAGING = 1,
  SYNC = 2,
  COMBINED = 3,
  FAILBACK = 4,
}
